import { gql } from "@apollo/client";
import CollectionCardFieldsFragment from "~/src/components/collection/graphql/fragments/CollectionCardFieldsFragment";

export default gql`
  query SelfieCollections($cursor: String, $searchQuery: String, $lastVisitDate: DateTime) {
    listAllCollections(filterByViewerBookmarkStatus: SAVED, limit: 4, cursor: $cursor, searchQuery: $searchQuery) {
      items {
        ...CollectionCardFields
        newContentCounters(lastVisitAnchor: LAST_TRACKED_VIEWER_VISIT, lastVisitDate: $lastVisitDate) {
          groupsCount
          productsCount
          projectsCount
          storiesCount
          governmentsCount
        }
      }
      pageInfo {
        cursor
        hasNextPage
      }
      totalCount
    }
  }

  ${CollectionCardFieldsFragment}
`;
